document.querySelectorAll('.u-product-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const button = form.querySelector('[data-u-atc-button]');
        button.disabled = true;

        try {
            await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
            
            button.classList.add('atc-added');
            setTimeout(() => {
                button.classList.remove('atc-added');
                button.disabled = false;
            }, 2000);

            const cart = await fetch('/cart.js').then(r => r.json());
            
            import('@theme/events').then(({ CartUpdateEvent }) => {
                document.dispatchEvent(new CartUpdateEvent(cart, 'manual-trigger', {
                    itemCount: cart.item_count,
                    source: 'u-featured-products',
                    sections: {}
                }));
            });

            setTimeout(() => document.querySelector('cart-drawer-component')?.open(), 300);
        } catch (error) {
            console.error('Error:', error);
            button.disabled = false;
        }
    });
});
// Call the function
document.addEventListener('DOMContentLoaded', function () {
  initTrandingSlider();
});

function initializeBannerReviewSwiper() {
document.querySelectorAll('.myBannerReviewSwiper').forEach((slider) => {
    if (slider.swiper) return;
    const section = slider.closest('.s-banner-slider-main-');
    new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
        el: section.querySelector('.u-banner-pagination'),
        clickable: true,
    },
    });
});
}
// document.addEventListener('DOMContentLoaded', initializeBannerReviewSwiper);
// document.addEventListener('shopify:section:load', initializeBannerReviewSwiper);

function initalizeinstaslider() {
    document.querySelectorAll('.mysimpleReviewSwiper').forEach((slider) => {
        if (slider.swiper) return;
        const section = slider.closest('.s-simple-slider-main-');
        new Swiper(slider, {
        slidesPerView: 6,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: '.u-simple-swiper-button-next',
            prevEl: '.u-simple-swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 14,
            },
            640: {
                slidesPerView: 4,
            },
            1020: {
                slidesPerView: 6,
            },
        },
        });
    });
}
document.addEventListener('DOMContentLoaded', initalizeinstaslider);
document.addEventListener('shopify:section:load', initalizeinstaslider);

function initTrandingSlider() {
    var TrandingSlider = new Swiper('.u-benefit-slide', {
    speed: 600,
    spaceBetween: 20,
    navigation: {
      nextEl: ".u-benefit-next",
      prevEl: ".u-benefit-prev",
    },
    breakpoints: {
      320: {
          slidesPerView: 1.2,
          spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3
      }
    }
  });
}

